import React from 'react';
import Button from '../../../ui/button/button';
import { useIdentityManager } from '../../../../common/hooks/useIdentityManager';
import useTranslate from '../../../../common/hooks/useTranslate';

import './login.scss';

const Login = () => {
  const identity = useIdentityManager();
  const { t } = useTranslate();

  return (
    <div className='login-wrapper'>
      <img src={'/branding/logoLogin.png'} alt='Logo' />
      <span className='login-welcome-text'>{t('LOGIN.WELCOME')}</span>
      <Button buttonStyle='button-wrapper button-wrapper-oval' handleClick={() => identity.signIn()}>
        {t('LOGIN.BUTTON_TEXT')}
      </Button>

      {identity.hasForgotPassword() &&
        <div className={'login-forgot-password'} role="button" onClick={() => identity.forgotPassword()}>{t('LOGIN.FORGOT_PASSWORD')}</div>}

      <span className='copyright hidden-mobile'>&#169; {t('LOGIN.COPYRIGHT')}</span>
    </div>
  );
};

export default Login;
